import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'app-rodape',
    templateUrl: './rodape.component.html',
    styleUrls: ['./rodape.component.scss']
})
export class RodapeComponent {
    @Input()
    deletavel: boolean = true

    @Input()
    editavel: boolean = true

    @Input()
    exibirBotoes: boolean = true

    @Output()
    eventSave = new EventEmitter();

    @Output()
    eventDelete = new EventEmitter();

    @Output()
    eventCancel = new EventEmitter();

    save(){ this.eventSave.emit()  }
    delete(){ this.eventDelete.emit() }
    cancelar(){ this.eventCancel.emit() }
}
